import React, { Component } from 'react';
import { connect } from 'react-redux';
import common from '../../../common';
import {
    openMobileFilter,
} from './../../../actions/FormationActions';
import {
    resetFilter,
} from './../../../actions/FilterActions';
import $ from 'jquery'

class ExpandedFiltersMobile extends Component {
    onResetFilter = () => {
        let pageName = "";
        if (window.location.pathname.indexOf("/manage-team")) {
            pageName = "/uclfantasy/my-team/transfers/"
        } else {
            pageName = "/uclfantasy/create-team/"
        }
        common.customTracking('Reset Filters', pageName);
        this.props.resetFilter();
    };
    onFilterTapToExpandCollapseInMob = (bool) => {
        let self = this;
        $('.si-sorting-wrap').animate({
            scrollTop: 0
        }, 500, function () {

        });
        self.props.openMobileFilter(bool);
    };

    render() {
        const filterCount = this.props.filterCount;
        const resetBtnClass = common.makeClasses({
            'si-visibility-hidden': filterCount === 0
        });
        return <div className="si-filter-header si-flexBox">
            <span className="si-title">{ this.props.trans.filterLabel }</span>
            <div className="si-reset-wrap">
                <span
                    onClick={ () => this.onResetFilter() }
                    className={ resetBtnClass }>{ this.props.trans.filterResetLabel }</span>
                <span className="si-btn si-btn-secondary-wb"
                    onClick={ () => this.onFilterTapToExpandCollapseInMob(false) }>{ this.props.trans.filterDone }</span>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        filterCount: state.formationData.playerFilters.filterCount,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetFilter: () => dispatch(resetFilter()),
        openMobileFilter: (bool) => dispatch(openMobileFilter(bool)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ExpandedFiltersMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/ExpandedFilterHeaderMobile.js